import { getUuid, Uuid } from '@sibe/utilities/common';
import type { HsObject3D } from '../objects/common/object-3d.class';
import type { HsRenderFilterType } from '../types/render-filter-type.type';
import type { HsCamera } from '../objects/cameras/camera.class';
import type { HsObjectQueue } from './object-queue.class';
import type { HsLayer } from './layer.class';

export abstract class HsRenderFilter<
  T extends HsObject3D,
  S extends HsCamera,
  U extends HsObjectQueue,
  L extends HsLayer
> {
  public readonly uuid: Uuid = getUuid();

  constructor(public filter: HsRenderFilterType<T, S, U, L>) {}
}
